<mwe-basic-card
  [headingNodeType]="headlineService.getHeadline(0)"
  cardTitle="tariff.additionalOptions.title"
  iconClass="fa-box-circle-check"
>
  <label
    [attr.aria-description]="isReadOnly() ? ('newClient.disabled' | translate) : null"
    [attr.title]="title() + ' wählen'"
    [ngClass]="[!isReadOnly() ? 'p-4 pointer' : '']"
    class="card-selectable mb-0"
    data-test="additional-options-checkbox"
  >
    <div class="row justify-content-between mb-3">
      <div class="col">
        <i class="fa fa-helmet-safety text-secondary" style="font-size: 2.5rem"></i>
      </div>

      <div class="col-auto">
        <div class="form-check">
          <input
            (change)="onCheckboxChange()"
            [attr.aria-label]="title()"
            [checked]="isSelected()"
            [disabled]="isCheckBoxDisabled()"
            class="form-check-input"
            type="checkbox"
          />
        </div>
      </div>
    </div>
    <mwe-headline [headlineLevelIncrement]="1" [text]="title()" cssClass="h6" data-test="tariff-card-additional-options-title" />
    <p class="text--legal mb-0">{{ tariff().category | correlatedCompanyReference }}</p>
  </label>
  @if (!isReadOnly()) {
    <mwe-expander [textKey]="infoText()" />
  }
</mwe-basic-card>
